import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../styles/Course.module.css";
import {
  Card,
  Container,
  Row,
  Col,
  Tabs,
  Tab,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import first from "../assets/img/first.png";

function Courses() {
  const [key, setKey] = React.useState("information");
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 767;

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const courseList = [
    { title: "جلسه اول", time: "11", id: 1 },
    { title: "جلسه دوم", time: "8", id: 2 },
    { title: "جلسه سوم", time: "31", id: 3 },
    { title: "جلسه چهارم", time: "91", id: 4 },
    { title: "جلسه پنجم", time: "87", id: 5 },
    { title: "جلسه ششم", time: "28", id: 6 },
    { title: "جلسه هفتم", time: "42", id: 7 },
    { title: "جلسه هشتم", time: "42", id: 8 },
    { title: "جلسه نهم", time: "10", id: 9 },
    { title: "جلسه دهم", time: "8", id: 10 },
  ];

  return (
    <div>
      <Header />
      <div className={styles.container2}>
        <div className={styles.cardContainer}>
          <Container>
            <Row>
              <Col sm>
                <Row>
                  <Col xs={12} md={8}>
                    <img
                      className={styles.productImage}
                      src={first}
                      alt="عکس دوره"
                    />
                  </Col>
                  <Col xs={6} md={4} style={{ position: "inherit" }}>
                    <Col
                      sm
                      style={{
                        width: "30%",
                        position: "absolute",
                        left: "5rem",
                      }}
                    >
                      <div className={styles.leftCol}>
                        <div className={styles.ticket}>
                          <strong className={styles.price}>قیمت:</strong>
                          <p class={styles.priceParagraph}>
                            <span>
                              1,000,000&nbsp;<span>تومان</span>
                            </span>
                          </p>
                        </div>
                        <div className={styles.buyButtonContainer}>
                          <button className={styles.button}>خرید ریالی</button>
                          <button
                            style={{ paddingRight: "30%" }}
                            className={styles.button}
                          >
                            خرید غیر ریالی
                          </button>
                        </div>
                        <p style={{ textAlign: "center" }}>امتیاز 0 از 0 رأی</p>
                      </div>
                      <div className={styles.leftCol2}>
                        <ListGroup variant="flush">
                          <ListGroup.Item>نوع دوره: تخصصی</ListGroup.Item>
                          <ListGroup.Item>240 دقیقه</ListGroup.Item>
                          <ListGroup.Item>3800 مگابایت</ListGroup.Item>
                        </ListGroup>
                      </div>
                    </Col>
                  </Col>
                </Row>

                <Card className={styles.informationCard}>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                  >
                    <Tab eventKey="information" title="اطلاعات دوره">
                      <h5 style={{ marginTop: "2rem" }}>معرفی دوره</h5>
                      <p>
                        بلاکچین به‌عنوان یک فن‌آوری بنیادی در زندگی روزمره بسیار
                        مفید خواهد بود. حجم بی‌شمار پژوهش‌ها، تعداد بی‌شمار
                        تراکنش‌ها و رمزارزهای مختلف، نشانگر این است که استفاده
                        از بلاکچین در تمامی زمینه‌ها رو به افزایش است. بلاکچین
                        امکان ثبت اطلاعات به‌صورت دائمی و بدون امکان تغییر را
                        فراهم می‌کند. از بلاکچین برای هر سیستمی که نیاز است
                        اعتماد به‌واسطه‌ها و افراد شخص ثالث کاهش یابد، می‌توان
                        استفاده نمود. در حال حاضر بزرگترین موارد استفاده از
                        بلاکچین، مربوط به امور مالی است که رقم تراکنش‌های انجام
                        شده از طریق بلاکچین به میلیاردها دلار می‌رسد. بلاکچین با
                        قابلیت همتابه‌همتا خود دست واسطه‌ها را از معاملات کوتاه
                        کرده است. در این دوره با اصول و مهارت های حوزه بلاکچین و
                        ارزهای دیجیتال و پروژه‌های مربوطه و خرید و فروش آنها
                        آشنا می‌شوید.
                      </p>
                      <h5>سرفصل مطالب</h5>
                      <p>
                        <h6>مفاهیم اولیه فن‌آوری بلاکچین (Blockchain):</h6>
                        <ul>
                          <li>معرفی فن‌آوری بلاکچین</li>
                          <li>تشریح مکانیز اجماع</li>
                          <li>مبانی فورک در بلاکچین و حملات فورک</li>
                          <li>مبانی انتقال در بلاکچین</li>
                          <li>اشنایی با قراردادهای هوشمند (Smart Contract)</li>
                        </ul>
                        <h6>ارز های دیجیتال:</h6>
                        <ul>
                          <li>دسته بندی در ارزهای دیجیتال</li>
                          <li>نحوه معرفی و شناسایی برترین ارزهای دیجیتال</li>
                          <li>تشریح پروژه‌ها</li>
                          <li>Ethereum</li>
                          <li>Ethereum 2</li>
                        </ul>
                      </p>
                      <h5>معرفی استاد:</h5>
                      <p>
                        رضا نورمحمدی دانشجوی دکترا و پروژهشگر و کارشناس حوزه هوش
                        مصنوعی و بلاکچین با بیش از 6 سال سابقه در حوزه فن‌آوری
                        بلاکچین و تجربه حضور به عنوان طراح , مجری و مشاور در
                        پروژه های مرتبط
                      </p>
                      <h5>چه کسانی میتوانند در دوره حضور یابند؟</h5>
                      <p>
                        شرکت در این دوره نیازمند تخصص و مهارت خاصی نبوده و این
                        دوره برای تمامی علاقه مندان به فعالیت در حوزه بلاکچین و
                        رمز ارزها مناسب است.
                      </p>
                    </Tab>
                    <Tab eventKey="list" title="لیست دوره">
                      <div style={{ marginTop: "2rem" }}>
                        {courseList.map((i) => (
                          <div className={styles.lists}>
                            <div className={styles.idContainer}>{i.id}</div>
                            <h5 style={{ paddingTop: ".5rem" }}>{i.title}</h5>
                            <p
                              style={{
                                marginRight: "auto",
                                paddingTop: ".5rem",
                              }}
                            >
                              {i.time} دقیقه
                            </p>
                          </div>
                        ))}
                      </div>
                    </Tab>
                  </Tabs>
                </Card>
                <div className={styles.banner}>
                  <div className={styles.requestText}>
                    <h3 style={{ color: "gray" }}>درخواست مشاوره</h3>
                    <button className={styles.buttonYellow}>
                      درخواست مشاوره
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <section className={styles.footer}>
          <Footer />
        </section>
      </div>
      {width < breakpoint ? (
        <button className={styles.stickyButton}>خرید ریالی</button>
      ) : null}
    </div>
  );
}

export default Courses;
